import createReducer from 'reducers/createReducer';

import { RecurringPayment } from 'actions/actionTypes';

const INITIAL_STATE = {
    recurringPayment: {
        isUseRecurringPayment: false,
        serviceStartDate: '',
        automaticPaymentDate: '',
    },
    paymentMethod: {
        bankAccountList: [],
        creditCardList: [],
    },
    addPaymentMethodType: '',
    deletePaymentMethodIdx: 0,
    paymentGatewayRequest: {
        isOpen: false,
        script: '',
        html: '',
    },
    paymentApprovalToken: '',
    paymentVerifyToken: '',
    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [RecurringPayment.CHANGE_PAYMENT_GATEWAY_REQUEST_OPEN]: (state, action) => (state.paymentGatewayRequest.isOpen = true),

    [RecurringPayment.LOAD_SHOP_RECURRING_PAYMENT_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [RecurringPayment.LOAD_SHOP_RECURRING_PAYMENT_SUCCESS]: (state, action) => {
        state.recurringPayment.isUseRecurringPayment = action.payload.isUseRecurringPayment;
        state.recurringPayment.serviceStartDate = action.payload.recurringPaymentRegistrationDate;
        state.recurringPayment.automaticPaymentDate = action.payload.automaticPaymentDay;
    },
    [RecurringPayment.LOAD_SHOP_RECURRING_PAYMENT_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [RecurringPayment.LOAD_SHOP_PAYMENT_METHOD_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [RecurringPayment.LOAD_SHOP_PAYMENT_METHOD_SUCCESS]: (state, action) => {
        state.paymentMethod = action.payload;
    },
    [RecurringPayment.LOAD_SHOP_PAYMENT_METHOD_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [RecurringPayment.ADD_SHOP_PAYMENT_METHOD_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;

        state.addPaymentMethodType = action.payload;
    },
    [RecurringPayment.ADD_SHOP_PAYMENT_METHOD_SUCCESS]: (state, action) => {
        state.paymentGatewayRequest.script = action.payload.script;
        state.paymentGatewayRequest.html = action.payload.html;
    },
    [RecurringPayment.ADD_SHOP_PAYMENT_METHOD_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [RecurringPayment.DELETE_SHOP_PAYMENT_METHOD_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;

        state.deletePaymentMethodIdx = action.payload;
    },
    [RecurringPayment.DELETE_SHOP_PAYMENT_METHOD_SUCCESS]: (state, action) => {
        state.deletePaymentMethodIdx = INITIAL_STATE.deletePaymentMethodIdx;
    },
    [RecurringPayment.DELETE_SHOP_PAYMENT_METHOD_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [RecurringPayment.SHOP_RECURRING_PAYMENT_CANCEL_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [RecurringPayment.SHOP_RECURRING_PAYMENT_CANCEL_SUCCESS]: (state, action) => {
        state.recurringPayment = INITIAL_STATE.recurringPayment;
        state.paymentMethod = INITIAL_STATE.paymentMethod;
        state.addPaymentMethodType = INITIAL_STATE.addPaymentMethodType;
        state.deletePaymentMethodIdx = INITIAL_STATE.deletePaymentMethodIdx;
        state.paymentGatewayRequest = INITIAL_STATE.paymentGatewayRequest;
        state.paymentApprovalToken = INITIAL_STATE.paymentApprovalToken;
        state.paymentVerifyToken = INITIAL_STATE.paymentVerifyToken;
    },
    [RecurringPayment.SHOP_RECURRING_PAYMENT_CANCEL_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [RecurringPayment.MY_BANK_ACCOUNT_PAYMENT_APPROVAL_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
        state.paymentApprovalToken = action.payload.paymentApprovalToken;
    },
    [RecurringPayment.MY_BANK_ACCOUNT_PAYMENT_APPROVAL_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [RecurringPayment.CREDIT_CARD_PAYMENT_VERIFY_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
        state.paymentVerifyToken = action.payload.paymentVerifyToken;
    },
    [RecurringPayment.CREDIT_CARD_PAYMENT_VERIFY_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },
});

export default reducer;
